import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PAGE_TITLES = {
  // ── Auth / Public ──────────────────────────────────────────
  "/":                                   "Home",
  "/homescreen":                         "Home",
  "/login":                              "Login",
  "/register":                           "Register",
  "/forgotpassword":                     "Forgot Password",
  "/join_amped":                         "Join Amped",
  "/payment-status":                     "Payment Status",
  "/delete-my-account":                  "Delete My Account",
  "/privacy-policy":                     "Privacy Policy",
  "/terms-and-conditions":               "Terms & Conditions",

  // ── Dashboards ─────────────────────────────────────────────
  "/home":                               "Dashboard",
  "/customerdashboard":                  "Customer Dashboard",
  "/cpodashboard":                       "CPO Dashboard",
  "/partner-dashboard":                  "Partner Dashboard",

  // ── Customer ───────────────────────────────────────────────
  "/station":                            "My Station",
  "/transaction":                        "Transactions",
  "/wallet":                             "Wallet",
  "/customer-profile":                   "My Profile",
  "/profile":                            "My Profile",
  "/family/family_account":             "Family Account",
  "/delete-my-account-token":            "Delete My Account",
  "/privacy-policy-view":                "Privacy Policy",
  "/faqs-view":                          "FAQs",

  // ── Map & Booking ──────────────────────────────────────────
  "/map/search-map":                     "Find a Station",
  "/map/book-now":                       "Book Now",
  "/map/booking_scanner":                "Scan Charger",
  "/map/booking_charger":                "Select Charger",
  "/map/booking_charger_start":          "Start Charging",
  "/map/booking_charger_stop":           "Stop Charging",
  "/map/booking_station_review":         "Write Review",
  "/map/instant_book":                   "Instant Book",
  "/map/history":                        "Booking History",
  "/map/viewbookingsummary":             "Booking Summary",
  "/map/view-schedulebooking-summary":   "Schedule Summary",
  "/map/schedule":                       "Schedule Booking",
  "/map/scheduledetails":                "Schedule Details",
  "/map/searchschedule":                 "Search Schedule",
  "/map/view-moredetails":               "Station Details",
  "/map/schedule-view-moredetails":      "Station Details",
  "/map/schedule-booking":               "Schedule Booking",
  "/map/vehiclelist":                    "My Vehicles",
  "/map/morenews":                       "EV News",
  "/map/newdetails":                     "News Details",
  "/map/unit-report":                    "Unit Report",
  "/map/refer-earn":                     "Refer & Earn",
  "/map/rewards-collected":              "Rewards Collected",

  // ── Admin / Management ─────────────────────────────────────
  "/users":                              "Users",
  "/roles":                              "Roles",
  "/rolesrequest":                       "Role Requests",
  "/chargers":                           "Chargers",
  "/charger-details_view":               "Charger Details",
  "/charger-log":                        "Charger Log",
  "/charging_stations":                  "Charging Stations",
  "/charging_stations/chargingstations_details": "Station Details",
  "/chargingstationhistory":             "Station History",
  "/reports":                            "Reports",
  "/settings":                           "Settings",
  "/activitylog":                        "Activity Log",
  "/leads":                              "Leads",
  "/offernotification":                  "Offer Notifications",
  "/offers":                             "Offers",
  "/cpooffers":                          "CPO Offers",
  "/superadminoffers":                   "Super Admin Offers",
  "/revenueinvoice":                     "Revenue Invoice",
  "/owner-expenses":                     "Expenses",
  "/new-properties":                     "New Properties",
  "/review":                             "Reviews",
  "/help-support":                       "Help & Support",

  // ── CPO ────────────────────────────────────────────────────
  "/cpo":                                "CPO",
  "/stations":                           "Stations",
  "/revenue":                            "Revenue",
  "/expenses":                           "Expenses",
  "/consumption":                        "Consumption",
  "/busytime":                           "Busy Time",

  // ── Partner ────────────────────────────────────────────────
  "/partners":                           "Partners",
  "/partner-revenue":                    "Partner Revenue",
  "/partner-live-tracking":              "Live Tracking",
  "/partner-consumption":                "Partner Consumption",
  "/partner-busytime":                   "Partner Busy Time",
  "/partner-landmark-view":              "Landmark Details",
  "/approved-land-mark":                 "Approved Landmarks",
  "/approved-landmark-details":          "Landmark Details",
  "/partner-expense-report":             "Expense Report",
  "/partner-elecricity-bill":            "Electricity Bill",
  "/partner-raise_request":              "Raise Request",
  "/partner-suggetion":                  "Suggestions",
  "/associate-partners-manage":          "Associate Partners",
  "/partner-lead-management":            "Lead Management",
  "/charger-service-request":            "Service Request",
  "/wall_balance-in_partner-view":       "Wallet Balance",
};

const BRAND = "Amped Energy";

const getTitle = (pathname) => {
  const lower = pathname.toLowerCase();
  const label = PAGE_TITLES[lower] || PAGE_TITLES[pathname];
  if (label) return `${label} | ${BRAND}`;

  // Fallback: convert the last path segment to Title Case
  const segment = pathname.split("/").filter(Boolean).pop() || "";
  const readable = segment
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return readable ? `${readable} | ${BRAND}` : BRAND;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.title = getTitle(pathname);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
